import React, { FunctionComponent } from "react"
import { Box, TextField, makeStyles, Theme } from "@material-ui/core"
import { InputLabel } from "../@citydna/common/InputLabel"
import { SchemaField } from "../featuer-layer-settings/schema"
import { Autocomplete } from "@material-ui/lab"
import { useFormContext, Controller } from "react-hook-form"

import { ArrowDropDownRounded as ArrowDropDownRoundedIcon } from "@material-ui/icons"
import { CloseRounded as CloseRoundedIcon } from "@material-ui/icons"

const useStyles = makeStyles<Theme>((theme) => ({
  autocomplete: {
    "& .MuiAutocomplete-endAdornment": {
      marginTop: -5,
    },
  },
}))

interface SelectFieldProps {
  field: SchemaField
  defaultValue?: string
}

export const SelectField: FunctionComponent<SelectFieldProps> = ({
  field,
  defaultValue,
}) => {
  const { control, errors } = useFormContext()
  const error = errors[field.name || ""]
  const classes = useStyles()

  return (
    <Box>
      <InputLabel>
        {field.alias}
        {!field.required && " (optional)"}
      </InputLabel>
      <Controller
        name={field.name || ""}
        control={control}
        defaultValue={
          defaultValue || (field.subvariant === "multiselect" ? [] : "")
        }
        rules={{ required: field.required }}
        render={({ value, onChange }) => (
          <Autocomplete
            multiple={field.subvariant === "multiselect"}
            options={field.options ? field.options.split(", ") : []}
            className={classes.autocomplete}
            popupIcon={<ArrowDropDownRoundedIcon />}
            closeIcon={<CloseRoundedIcon />}
            value={value || (field.subvariant === "multiselect" ? [] : "")}
            onChange={(e, newValue) => onChange(newValue)}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                color="secondary"
                name={field.name}
                placeholder={`Search for a ${field.alias?.toLowerCase()}`}
                fullWidth
                error={error}
              />
            )}
          />
        )}
      />
    </Box>
  )
}
